import global from 'global';
import { get, noop } from 'lodash';

import { validate } from './bridgeSchema';
import mockResolver from './mockResolver';

const bridgeFallbackName = 'tulipNativeBridge';

const symbols = {
  resolvers: Symbol('Adapters property'),
  mock: Symbol('Mock object property'),
  bridge: Symbol('Bridge property'),
  options: Symbol('Options property'),
};

const attachFallback = (fallback) => {
  global[bridgeFallbackName] = fallback;
};

const resolve = (options, resolvers) => resolvers.reduce(
  (promise, resolver) => promise.then(validate).catch(() => resolver(options)),
  Promise.reject(),
);

export default class Bridge {
  constructor(adapters = []) {
    this[symbols.resolvers] = [
      ...adapters,
      mockResolver(() => this[symbols.mock]),
    ];
  }

  async init(options) {
    this[symbols.options] = options;

    try {
      await this.reload();
      attachFallback(this[symbols.bridge]);
    } catch (e) {
      // No bridges found
    }

    return this;
  }

  get(path, defaultValue = undefined) {
    return path ? get(this[symbols.bridge], path, defaultValue) : this[symbols.bridge];
  }

  call(path, ...args) {
    const bridge = this[symbols.bridge];
    const method = get(bridge, path, noop);

    return bridge::method(...args);
  }

  async reload() {
    this[symbols.bridge] = await resolve(this[symbols.options], this[symbols.resolvers]);
  }

  mock(mockObject) {
    this[symbols.mock] = {
      __mock: true,
      ...mockObject,
    };

    /**
     * Attach mock synchronously, to prevent errors in Web Modules
     * which are not ready to use async bridge.
     *
     * TODO: remove it when all modules are refactored
     */
    if (!this[symbols.bridge]) {
      attachFallback(this[symbols.mock]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/Bridge/Bridge.js